import config from 'src/constants/config';
import htmlParse from 'html-react-parser';
import NormalButton from 'src/components/Buttons/NormalButton';
import React from 'react';
import SVG from 'src/components/Images/SvgRenderer';
import useStyles from './style';
import { getUserRole } from 'src/utils/useUser';
import { useAppSelector } from 'src/hooks/redux-hooks';
import { useTranslation } from 'react-i18next';

type SectionType = {
  section: any;
  title: any;
  header: any;
  text: any;
  handleBack: any;
  handleNext: any;
};

const Section: React.FunctionComponent<SectionType> = ({ section, title, header, text, handleBack, handleNext }) => {
  
  const userData = useAppSelector((state: any) => state.user);
  
  const { t } = useTranslation();

  const classes = useStyles({
    section: section,
    role: getUserRole(userData.userObject.roleType)
  });

  const contentData: any = {
    title: title,
    header: header,
    text: text,
  };

  const getContent = (type: any) => {
    return htmlParse(contentData[type][getUserRole(userData.userObject.roleType)]);
  };

  return (
    <div className={classes.section}>
      <div className={classes.wrapper}>
        <div className={classes.header}>
          <SVG src={config.APP_LOGO}/>
        </div>
        <div className={classes.content}>
          <div className={classes.info}>
            <span>
              {getContent("title")}
            </span>
            <em>
              {getContent("header")}
            </em>
            <p>
              {getContent("text")}
            </p>
          </div>
          <div className={classes.buttons}>
            <NormalButton buttonType="secondary" onClick={handleBack}>
              {t('back')}
            </NormalButton>
            <NormalButton buttonType="primary" onClick={handleNext}>
              {t('next')}
            </NormalButton>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Section;